import { Navigate, useRoutes } from 'react-router-dom';
import AuthGuard from './guards/AuthGuard';
// import UnAuthGuard from './guards/UnAuthGuard';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//

// import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import UsersPage from './pages/UserPage';
import UsersAddPage from './pages/UserAddPage';
import UsersEditPage from './pages/UserEditPage';
// import AdminPage from './pages/AdminPage';
// import AdminAddPage from './pages/AdminAddPage';
// import AdminEditPage from './pages/AdminEditPage';

import AccountEditPage from './pages/AccountEditPage';
import AccountAddPage from './pages/AccountAddPage';
import AccountPage from './pages/AccountPage';

import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      element: <AuthGuard component={<DashboardLayout />} />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        { path: 'dashboard', element: <DashboardAppPage /> },
        { path: 'accounts/edit/:id', element: <AccountEditPage /> },
        { path: 'accounts/add', element: <AccountAddPage /> },
        { path: 'accounts', element: <AccountPage /> },
        { path: 'users/edit/:id', element: <UsersEditPage /> },
        { path: 'users/add', element: <UsersAddPage /> },
        { path: 'users', element: <UsersPage /> },
        { path: 'categories', element: <CategoryPage /> },
        { path: 'products', element: <ProductPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
